import { shape, string, object, array, arrayOf, bool, number } from 'prop-types'

export const occurrencesType = shape({
  summary: bool.isRequired,
  times: arrayOf(
    shape({
      startAt: string.isRequired,
      endAt: string,
    })
  ),
  timeZone: string.isRequired,
})

export const imageType = shape({
  alt: string,
  src: string.isRequired,
})

export const contentAnalyticsMetaDataType = shape({
  correlationId: string,
  title: string,
  promotion: shape({
    creative: string,
  }),
})

export const entryType = shape({
  entry: shape({
    title: string.isRequired,
    category: string.isRequired,
    desktopImage: imageType,
    mobileImage: imageType,
    body: string.isRequired,
    startTime: string,
    endTime: string,
    termsAndConditions: string,
    physicalAddress: string,
    telephoneNumber: string,
    store: object,
    startAt: string,
    endAt: string,
    occurrences: occurrencesType,
    analyticsMetaData: contentAnalyticsMetaDataType,
  }),
})

export const callToActionType = arrayOf(
  shape({
    category: string.isRequired,
    address: string.isRequired,
  })
)

export const centreType = shape({
  sys: shape({
    id: string.isRequired,
  }),
  title: string.isRequired,
  telephoneNumber: string.isRequired,
  emailAddress: string.isRequired,
  facebook: string.isRequired,
  twitter: string.isRequired,
  instagram: string.isRequired,
  physicalAddress: string.isRequired,
  state: string.isRequired,
  postcode: string.isRequired,
  suburb: string.isRequired,
  navigationMenu: array,
  slug: string.isRequired,
  country: string.isRequired,
  jibestreamV4VenueId: number,
})

export const promotionType = shape({
  image: shape({
    url: string,
    alt: string,
  }).isRequired,
  title: string.isRequired,
  heading: string.isRequired,
  shortDescription: string.isRequired,
  callToActionLabel: string.isRequired,
  callToActionAddress: string.isRequired,
  eventCategory: string,
  eventAction: string,
})

export const EventElement = shape({
  target: shape({
    value: string,
  }),
})
